import React from 'react';
import SEO from '../components/SEO';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { blogData } from '../data/blogData';
import { FaClock, FaArrowRight } from 'react-icons/fa';
import './Blog.css';

const Blog = () => {
  React.useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <SEO
        title="Blog Immobilier — Conseils & Analyses du Marché | ATAA REALTY"
        description="Articles, conseils et analyses sur l'immobilier au Maroc : investissement, juridique, gestion locative, marché et tendances par les experts d'ATAA REALTY."
        canonical="https://ataarealty.com/blog"
        keywords="blog immobilier Maroc, conseils immobiliers, analyse marché immobilier, investissement immobilier Maroc"
      />
      <Navbar />
      
      <div className="blog-page-header">
        <div className="overlay-dark"></div>
        <div className="container">
          <h1>Le Blog de l'Expert</h1>
          <p>Conseils, Analyses et Tendances du marché immobilier</p>
        </div>
      </div>

      <div className="container blog-page-container">
        <div className="blog-grid">
          {blogData.map((item) => (
            <div className="blog-card-full" key={item.id}>
              <div className="blog-thumb">
                <img src={item.image} alt={item.title} />
                <span className="category-tag">{item.category}</span>
              </div>
              <div className="blog-content-body">
                <div className="date-meta"><FaClock /> {item.date}</div>
                <h3>{item.title}</h3>
                <p>{item.excerpt}</p>
                <Link to={`/blog/${item.id}`} className="read-more">
                   Lire la suite <FaArrowRight />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Blog;